import { Component } from '@angular/core';
import { MatSelectionListChange } from '@angular/material/list';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'sfo-flags',
  templateUrl: './flags.component.html',
  standalone: false,
})
export class FlagsComponent {
  flags = [
    {
      name: 'export.debugPDF.enabled',
      title: 'Debug PDF',
      description: 'Include debug information in PDF exports (new engine)',
      get: (): boolean => localStorage.getItem('export.debugPDF.enabled') != undefined,
      set: (value: boolean) =>
        value
          ? localStorage.setItem('export.debugPDF.enabled', 'true')
          : localStorage.removeItem('export.debugPDF.enabled'),
    },
    {
      name: 'intelligence.disableCacheReads',
      title: 'Disable Intelligence Cache Reads',
      description: 'Always run intelligence processing, never using cached results',
      get: (): boolean =>
        localStorage.getItem('intelligence.disableCacheReads') != undefined,
      set: (value: boolean) =>
        value
          ? localStorage.setItem('intelligence.disableCacheReads', 'true')
          : localStorage.removeItem('intelligence.disableCacheReads'),
    },
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
  ) {
    if (this.route.snapshot.params?.id) {
      const flag = this.flags.find((f) => f.name.startsWith(this.route.snapshot.params.id));
      if (flag) {
        flag?.set(true);
        this.snackBar.open(flag.title + ' enabled', undefined, { duration: 5000 });
        this.router.navigateByUrl('/');
      } else {
        this.snackBar.open('Feature not found', undefined, { duration: 5000 });
        this.router.navigateByUrl('/');
      }
    }
  }

  change(event: MatSelectionListChange) {
    for (let option of event.options) {
      const flag = this.flags.find((f) => f.name === option.value);
      flag?.set(option.selected);
    }
  }
}
